module.exports = __webpack_public_path__ + "img/cart.5e49c288.png";